import React from "react";
import { Provider } from "react-redux";
import { useTranslation } from "react-i18next";
import "./App.css";
import { store } from "./app/store";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import { LocalizationProvider } from "@mui/x-date-pickers";
import ThemeContainer from "./components/Containers/ThemeContainer";
import AppRouter from "./router/AppRouter";
import MetaSDKLoader from "./components/Containers/MetaSDKLoader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { UploadFilesProvider } from "./contexts/UploadFilesContext";
import * as Sentry from "@sentry/react";
import { ChatProvider } from "./contexts/ChatContext";

const stripePromise = (async () => {
  try {
    return await loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);
  } catch (err) {
    console.error(err);
    window.location.reload();
  }
})();

if (import.meta.env.VITE_IS_STAGING === "false") {
  Sentry.init({
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 0.2,
    dsn: import.meta.env.VITE_SENTRY_URL,
  });
}

function App() {
  const { i18n } = useTranslation();
  const adapterLocale = i18n.language?.startsWith("es") ? es : enUS;

  return (
    <React.Fragment>
      <Elements stripe={stripePromise}>
        <Provider store={store}>
          <ThemeContainer>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={adapterLocale}
            >
              <UploadFilesProvider>
                <MetaSDKLoader />
                <ChatProvider>
                  <AppRouter />
                </ChatProvider>
              </UploadFilesProvider>
            </LocalizationProvider>
          </ThemeContainer>
        </Provider>
      </Elements>
    </React.Fragment>
  );
}

export default App;
